export const INVOICE_CREATE_SCOPE = 'invoices-write';